import Cookies from "js-cookie";

const COOKIE_NAME = "rb_cookie_consent";

/* Get consent */
export const getCookieConsent = () => {
  return Cookies.get(COOKIE_NAME);
};

/* Set consent */
export const setCookieConsent = (value) => {
  Cookies.set(COOKIE_NAME, value, {
    expires: 365,
    sameSite: "Lax",
    secure: true,
  });
};

/* Remove consent (optional) */
export const clearCookieConsent = () => {
  Cookies.remove(COOKIE_NAME);
};
